import { useState, useEffect, useContext } from "react";
import UserContext from "../Context/UserContext";

const Dashboard = () => {
  const [images, setImages] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const [savedItems, setSavedItems] = useState([]);
const auth = useContext(UserContext)
  // Fetch saved jewelry items on component mount



  useEffect(() => {
    fetchSavedItems();
  }, []);

  const fetchSavedItems = async () => {
    try {
      // const response = await fetch("https://jewerly-56a3c50292db.herokuapp.com/api/jewelry");
      // const data = await response.json();
      // setSavedItems(data);
    } catch (error) {
      console.error("Error fetching saved items:", error);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFiles(e.target.files);
    }
  };

  const handleFiles = (files) => {
    const newImages = Array.from(files)
      .filter((file) => file.type.startsWith("image/"))
      .map((file) => ({
        id: Math.random().toString(36).substr(2, 9),
        file,
        preview: URL.createObjectURL(file),
        description: "",
        cat: "Select Category",
        sku: "",
      }));
    setImages((prev) => [...prev, ...newImages]);
  };

  const updateImageDetails = (id, field, value) => {
    setImages((prev) =>
      prev.map((img) => (img.id === id ? { ...img, [field]: value } : img))
    );
  };

  const removeImage = (id) => {
    setImages((prev) => prev.filter((img) => img.id !== id));
  };

  const uploadImages = async () => {
    const formData = new FormData();
    const details = images.map(({ description, cat, sku }) => ({
      description,
      cat,
      sku,
    }));

    images.forEach((image) => {
      formData.append("images", image.file);
    });
    formData.append("details", JSON.stringify(details));

    try {
      const response = await fetch("https://jewerly-56a3c50292db.herokuapp.com/api/upload", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (response.ok) {
        alert("Photos and details uploaded successfully!");
        setImages([]); // Clear images after successful upload
        fetchSavedItems(); // Refresh saved items
      } else {
        alert("Upload failed: " + result.message);
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload failed: Server error");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Upload Jewelry Photo</h1>
        <div
          className={`border-2 border-dashed rounded-lg p-6 mb-6 text-center ${
            dragActive ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-gray-50"
          }`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <p className="text-gray-600 mb-2">Drag and drop your jewelry photos here, or</p>
          <label
            htmlFor="file-upload"
            className="cursor-pointer bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Select Photos
          </label>
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            multiple
            className="hidden"
            onChange={handleChange}
          />
        </div>
        {images.length > 0 && (
          <div>
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Pending Uploads</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {images.map((image) => (
                <div key={image.id} className="relative group bg-gray-50 p-4 rounded-lg shadow">
                  <img
                    src={image.preview}
                    alt="Jewelry preview"
                    className="w-full h-48 object-cover rounded-lg mb-4"
                  />
                  <div className="space-y-2">
                    <textarea
                      placeholder="Description (e.g., Elegant diamond necklace)"
                      value={image.description}
                      onChange={(e) =>
                        updateImageDetails(image.id, "description", e.target.value)
                      }
                      className="w-full p-2 border rounded text-sm"
                      rows="3"
                    />
                    <select
                      value={image.cat}
                      onChange={(e) => updateImageDetails(image.id, "cat", e.target.value)}
                      className="w-full p-2 border rounded text-sm"
                    >
                      <option disabled>Select Category</option>
                      <option value="Bracelets">Bracelets</option>
                      <option value="Necklaces">Necklaces</option>
                      <option value="Earrings">Earrings</option>
                      <option value="Collars">Collars</option>
                      <option value="Other">Other</option>
                    </select>
                    <input
                      type="text"
                      placeholder="SKU"
                      value={image.sku}
                      onChange={(e) => updateImageDetails(image.id, "sku", e.target.value)}
                      className="w-full p-2 border rounded text-sm"
                    />
                  </div>
                  <button
                    onClick={() => removeImage(image.id)}
                    className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
        {images.length > 0 && (
          <button
            className="mt-6 bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600"
            onClick={uploadImages}
          >
            Upload All
          </button>
        )}
        {savedItems.length > 0 && (
          <div className="mt-8">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">Saved Jewelry Items</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {savedItems.map((item) => (
                <div key={item._id} className="bg-gray-50 p-4 rounded-lg shadow">
                  <img
                    src={item.imagePath}
                    alt={item.description || "Jewelry"}
                    className="w-full h-48 object-cover rounded-lg mb-4"
                  />
                  <p className="text-sm text-gray-600">Description: {item.description || "N/A"}</p>
                  <p className="text-sm text-gray-600">Category: {item.category || "N/A"}</p>
                  <p className="text-sm text-gray-600">SKU: {item.sku || "N/A"}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;